import { FC, useState } from 'react';
import { useFormikContext } from 'formik';
import { Card } from '../../../base-components/Card.js';
import { Delimiter } from '../../../base-components/Delimiter.js';
import { FormTextInput } from '../../../base-components/FormTextInput.js';
import { CollapseButton } from '../components/CollapseButton.js';
import { FormSelectRegionModal } from '../components/FormSelectRegionModal.js';
import { Row } from '../components/Row.js';
import { PurchasesState } from '../Purchases.type.js';
import styles from './Filter.module.scss';
import { Reference } from './Filter.type.js';
import { SelectableOptions } from './Filter.type.js';
import { Matches } from './Filter.type.js';
import { useSyncQueryWithFilter } from '../hooks/useQueryParams.js';
import { Stats } from '../Stats/index.js';
import type { SortByOption } from '../types.js';
import useModalState from '@/components/_hooks/useModalState.js';
import { FilterMenu } from './index.js';

export interface FilterProps {
  reference: Reference;
  selectableOptions: SelectableOptions;
  matches: Matches;

  emptyFilterState: PurchasesState;

  isLoading: boolean;
  isRegionsModalVisible: boolean;
  showRegionsModal: () => void;
  sortByOptions: SortByOption[];
  total: number;
  hideRegionsModal: () => void;
}

export const Filter: FC<FilterProps> = ({
  reference,
  selectableOptions,
  matches,
  emptyFilterState,
  isLoading,
  isRegionsModalVisible,
  showRegionsModal,
  sortByOptions,
  total,
  hideRegionsModal,
}) => {
  const [collapsed, setCollapsed] = useState(true);
  const [isFilterMenuVisible, showFilterMenu, hideFilterMenu] = useModalState();
  const { setValues } = useFormikContext<PurchasesState>();

  useSyncQueryWithFilter(setValues);

  return (
    <Card className={styles.card}>
      <Row className={styles.searchRow}>
        <FormTextInput
          name="search"
          placeholder="Введите номер или наименование закупки на Praktis.lot или ЕИС, ИНН, название заказчика"
          appearance="compact"
          className={styles.control}
        />
        <CollapseButton collapsed={collapsed} onClick={showFilterMenu} />
      </Row>

      <Stats
        referenceSortByOptions={sortByOptions}
        total={total}
        isLoading={isLoading}
      />

      {isFilterMenuVisible && (
        <FilterMenu
          emptyFilterState={emptyFilterState}
          matches={matches}
          onHide={hideFilterMenu}
          selectableOptions={selectableOptions}
          showRegionsModal={showRegionsModal}
        />
      )}

      {isRegionsModalVisible && (
        <FormSelectRegionModal
          name="region"
          regions={reference.regions}
          districts={reference.districts}
          onHide={hideRegionsModal}
          matches={matches?.regions}
        />
      )}
    </Card>
  );
};
